module.exports = __webpack_public_path__ + "static/img/hefeiwei.bcba835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hefeiwei.png
// module id = J+TT
// module chunks = 1